import { GameTileProps } from '../../components/modular-grid/types';
import config from '../../config';
import { fetchJackpotsV2 } from '../../model/jackpotsV2';
import { JackpotsV2ResponseType } from '../../types/jackpotTypes';
import { groupJackpotGamesByAllowedProviders } from './groupJackpotGamesByAllowedProviders';

type GameType = Pick<GameTileProps, 'jackpotCode' | 'provider'>;

export const getJackpotsV2ForGames = async (
  allGames: GameType[],
  currency?: string
) => {
  const groupedGames = groupJackpotGamesByAllowedProviders(
    allGames,
    config.features.jackpotsV2.allowedProviders || []
  );
  const jackpots: Record<string, JackpotsV2ResponseType> = {};
  for (const gameProvider in groupedGames) {
    const games = groupedGames[gameProvider];
    const gamesJackpotCodes = games
      .map(game => game.jackpotCode)
      .filter((code, index, self) => self.indexOf(code) === index) as string[];

    const fetchedJackpots = await fetchJackpotsV2({
      currency,
      gamesJackpotCodes,
      provider: gameProvider,
    });
    jackpots[gameProvider] = fetchedJackpots;
  }
  return { jackpots };
};
